import './class-component-hooks.ts'
import Vue from 'vue'
import axios from 'axios'
import VConfirmDialog from './plugins/confirm'
//@ts-ignore
import vuetify from './plugins/vuetify'
import App from './App.vue'
import { StoreHelper } from './plugins'
import createRouter from './router'
import store from './store'
import {i18n} from'./locale/vueI18n'
import '@/filters/formatDistance' 
import '@/filters/formatAddress' 
import '@/filters/formatDate'
import '@/filters/formatDuree'
import '@/filters/currency'
import '@/filters/poids' 
import '@/filters/tva'
import '@/filters/moyenPaiement' 
import '@/filters/capitalize'
import '@/filters/tel'
import '@/filters/formatDay'
import '@/filters/colorStatusCmd'
import '@/filters/statusCmd'
import '@/filters/colorStatusInscription'
import '@/filters/statusInscription'
import '@/filters/colorStatusCarte'
import '@/filters/statusCarte'
import '@/filters/statusAbo'
import '@/filters/formatFinValidite'
import '@/filters/formatAge'
import VuetifyConfirm from './plugins/confirm'
import 'leaflet/dist/leaflet.css'
//@ts-ignore
import VueCalendly from 'vue-calendly';



/*import { VueperSlides, VueperSlide } from 'vueperslides-router'
import 'vueperslides-router/dist/vueperslides.css'*/

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import CKEditor from 'ckeditor4-vue' 
import NumberFieldFactor from '@/components/shared/NumberFieldFactor.vue'
import CheckState from '@/components/shared/CheckState.vue'
import ReadImage from '@/components/image/ReadImage.vue'
import MainLoading from '@/components/shared/MainLoading.vue'
import MonthPicker from '@/components/shared/MonthPicker.vue' 
import SearchDrawer from '@/components/shared/SearchDrawer.vue'
import SearchDialog from '@/components/shared/SearchDialog.vue'
import MenuAdministration from '@/components/administration/MenuAdministration.vue'

import Draggable from 'vuedraggable'
import VueClipboard from 'vue-clipboard2'



Vue.component('number-field-factor',NumberFieldFactor)
Vue.component('check-state',CheckState)
Vue.component('upload-image',ReadImage)
Vue.component('main-loading',MainLoading)
Vue.component('month-picker',MonthPicker)
Vue.component('draggable',Draggable) 
Vue.component('vue-slick-carousel',VueSlickCarousel) 

Vue.component('search-drawer',SearchDrawer)
Vue.component('search-dialog',SearchDialog)
Vue.component('menu-administration',MenuAdministration)



import  types from '@/store/all-action-types'

/* Correction Icon LeafLet */
import { Icon } from 'leaflet'
//@ts-ignore
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'), 
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(VuetifyConfirm, { vuetify,
  buttonTrueText: 'Oui', 
  buttonFalseText: 'Non', })
  
Vue.use( CKEditor )


Vue.config.productionTip = false
Vue.use(VConfirmDialog)
Vue.use(StoreHelper)
Vue.use(VueClipboard)
Vue.use(VueCalendly);

//On regarde si on est dans le cas d'un authorisation auto avec FULLTRUST_ALLOWED
const urlParams = new URLSearchParams(window.location.search);
const autolog = urlParams.get("autolog");

export const router = createRouter(store)

if((autolog?.length ?? 0) > 0) {
  store.dispatch(types.AUTH_AUTOLOG_REQUEST,autolog).finally(()=> {
    urlParams.delete("autolog")    
    window.history.replaceState({}, '', `${location.pathname}`); 
    new Vue({
      i18n,
      //@ts-ignore
      vuetify,
      router,
      store,
      render: h => h(App),
      mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
    }).$mount('#app')    
  })
}
else{
  store.dispatch(types.AUTH_USER_REQUEST).finally(()=>{ 
    new Vue({
      i18n,
      //@ts-ignore
      vuetify,
      router,
      store,
      render: h => h(App),
      mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
    }).$mount('#app')
  })
  }


 